import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2 6.78571L12.6667 6.78572M12.6667 6.78572C12.6667 8.32422 13.8606 9.57143 15.3333 9.57143C16.8061 9.57143 18 8.32422 18 6.78571C18 5.24721 16.8061 4 15.3333 4C13.8606 4 12.6667 5.24721 12.6667 6.78572ZM7.33333 14.2143L18 14.2143M7.33333 14.2143C7.33333 15.7528 6.13943 17 4.66667 17C3.19391 17 2 15.7528 2 14.2143C2 12.6758 3.19391 11.4286 4.66667 11.4286C6.13943 11.4286 7.33333 12.6758 7.33333 14.2143Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgFilter;
